export default __webpack_public_path__ + "static/media/RedCliffInn.7595c82e.jpg";